/**
 * Directive: datePickerPosition
 */
angular.module('acme.common.directive.datepickerPosition', ['ui.bootstrap.datepicker'])

/**
 * @ngdoc directive
 * @name datepickerPosition
 * @description
 * Directive that positions datepicker popup to the right or left. Bootstrap support only to the left.
 * This directive should be added to datepicker element (input) and given alignment value.
 * Currently implemented values are 'right' and 'left'.
 * If directive is not added to the element or it is added but has invalid value, alignment to the left will be used.
 */
.directive('datepickerPosition', [function() {
  return {
    restrict: 'A',
    scope: true,
    priority: 1,
    link: function(scope, element, attrs) {
      // I polute scope here, but it seems to be the best way!
      scope._getDatepickerInputWidth = function() {
        return element.outerWidth(); // width + padding + border
      };
      scope._getDatepickerPosition = function() {
        return attrs.datepickerPosition;
      };
    }
  };
}])

/**
 * @ngdoc directive
 * @name datepickerPositionInner
 * @description
 * Directive that aligns datepicker popup according to the input element.
 * It must be placed on datepicker popup element (in bootstrap template).
 */
.directive('datepickerPositionInner', [function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      scope.$watch('position', function(position) {
        if (position && scope._getDatepickerInputWidth) {
          if (scope._getDatepickerPosition() == 'right') {
            var positionShift = element.outerWidth() - scope._getDatepickerInputWidth();
            position.left -= positionShift;
          }
        }
      });
    }
  };
}]);

// Overrides default template for bootstrap UI
angular.module("template/datepicker/popup.html", ['acme.common.directive.datepickerPosition']).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/popup.html",
      "<ul datepicker-position-inner aria-hidden=\"{{ (isOpen && 'block') ? false : true }}\" class=\"dropdown-menu\" ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\">\n" +
      "	<li ng-transclude></li>\n" +
      "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
      "		<span class=\"btn-group\">\n" +
      "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"today()\" title=\"Click to select today's date\">{{ currentText }}</button>\n" +
      "			<button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"showWeeks = ! showWeeks\" ng-class=\"{ active: showWeeks }\" title=\"Click to show or hide weeks\">{{ toggleWeeksText }}</button>\n" +
      "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"clear()\" title=\"Click to clear field\">{{ clearText }}</button>\n" +
      "		</span>\n" +
      "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"isOpen = false\" title=\"Click to close\">{{ closeText }}</button>\n" +
      "	</li>\n" +
      "</ul>\n" +
      "");
}]);
